<template>
  <div>
    <v-card
      tile
      id="picsView"
      class="picsArea ma-0 pa-0"
      :style="{ background: $vuetify.theme.themes[theme].background }"
    >
      <v-carousel
        :continuous="false"
        :cycle="cycle"
        :dark="darkTheme"
        :light="lightTheme"
        :show-arrows="arrow"
        hide-delimiter-background
        delimiter-icon="circle"
        height="100%"
      >
        <v-row
          class="mx-auto pt-2 ml-10 mr-10"
          width="200px"
          justify="center"
          align="center"
        >
          <!-- working -->
          <!-- :item-value="(item) => item.id + ' - ' + item.fileglb" -->
          <v-autocomplete
            style="font-family: Nunito Sans !important"
            id="autoC"
            v-model="select"
            :loading="loading"
            :items="serverItems"
            :item-text="(item) => item.filename + ''"
            :item-value="(item) => item"
            :search-input.sync="search"
            prepend-icon="mdi-magnify"
            :dark="darkTheme"
            :light="lightTheme"
            :color="colorTheme"
            :item-color="colorTheme"
            cache-items
            hide-no-data
            hide-details
            label="Which file you are looking for?"
          ></v-autocomplete>
        </v-row>
        <v-carousel-item v-for="item in carouselItems" :key="item.filepng">
          <v-row class="fill-height mt-n10" justify="center" align="center">
            <v-img
              @click="funcc(item.fileglb, item.id)"
              contain
              :src="item.filepng"
              :alt="item.filepng"
              style="height: 80%; filter: drop-shadow(0 0 0.5rem #808080)"
            ></v-img>
          </v-row>
        </v-carousel-item>
      </v-carousel>
    </v-card>
    <div
      id="midB1"
      style="position: absolute; top: 56%; right: 50%; z-index: 5"
    >
      <v-card
        width="50"
        height="6"
        rounded="xl"
        color="grey"
        v-on:dblclick="toggleView()"
        style="margin-top: 0.2em; cursor: pointer"
      ></v-card>
    </div>

    <div id="midB2" style="position: absolute; top: 56%; right: 0; z-index: 5">
      <v-row class="justify-end ma-0 pa-0 mt-1 mr-2">
        <!-- elevation="5" -->

        <v-btn
          :elevation="gridTick"
          icon
          v-on:click="changeLayout('grid')"
          v-bind:class="{ active: layout == 'grid' }"
          title="Grid"
        >
          <v-icon>apps</v-icon>
        </v-btn>
        <v-btn
          :elevation="listTick"
          icon
          v-on:click="changeLayout('list')"
          v-bind:class="{ active: layout == 'list' }"
          title="List"
        >
          <v-icon>list</v-icon>
        </v-btn>
      </v-row>
    </div>
    <v-card
      tile
      id="cmsView"
      elevation="0"
      class="foldersArea2 expand ma-0 pa-0 pt-2"
      :style="{ background: $vuetify.theme.themes[theme].background }"
    >
      <v-card
        class="mx-auto ma-0 pa-0 pr-12 pl-10"
        tile
        style="margin: 0; padding: 0"
        :style="{ background: $vuetify.theme.themes[theme].background }"
      >
        <v-content class="ma-0 pa-0">
          <ul
            v-if="layout === 'grid'"
            class="grid"
            style="font-family: Nunito Sans"
          >
            <v-card
              class="ma-0 pa-0"
              style="text-align: center"
              color="transparent"
              elevation="0"
            >
              <div v-if="griddata" class="mt-2">
                <li
                  v-for="(item, index) in serverItems"
                  :key="index"
                  class="ml-2"
                >
                  <v-card width="118" elevation="5" rounded="10" color="grey">
                    <v-img
                      rounded
                      contain
                      aspect-ratio="1"
                      width="120"
                      height="120"
                      style="
                        cursor: pointer;
                        filter: drop-shadow(0 0 0.5rem #808080);
                      "
                      :src="item.filepng"
                      @click="grid(item)"
                    ></v-img>
                  </v-card>
                </li>
              </div>
              <div v-if="!griddata">
                <div>
                  <v-row>
                    <v-col cols="1" class="mt-9">
                      <v-icon @click="gridicon((griddata = true))"
                        >mdi-step-backward</v-icon
                      >
                    </v-col>

                    <v-col cols="3" class="mt-n5 ml-n2 ma-0 pa-0">
                      <v-img
                        contain
                        aspect-ratio="1"
                        width="120"
                        height="120"
                        :src="dataitem.filepng"
                        style="filter: drop-shadow(0 0 0.5rem #808080)"
                      >
                      </v-img>
                    </v-col>
                    <!-- <v-col cols="3" class="grid mt-11 ma-0 pa-0"> -->
                    <v-col cols="3" class="mt-11 ma-0 pa-0">
                      <p
                        style="font-size: 16px; font-weight: 600; opacity: 0.8"
                      >
                        {{ dataitem.filename }}
                      </p>
                    </v-col>
                    <v-col cols="3" class="ma-0 pa-0 mt-2">
                      <v-avatar
                        class="ml-2 mt-10"
                        v-for="(item, index) in itemscolor"
                        :key="index"
                        :color="item.color"
                        @click="colorf(item)"
                        size="14"
                      ></v-avatar>
                    </v-col>
                    <v-col cols="1" class="mr-n2 ma-0 pa-0 mt-2">
                      <v-btn icon class="mt-7" @click="deleteItem(item)">
                        <v-icon> mdi-delete-outline </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-divider class="mx-16 mt-n6 ml-15"></v-divider>
                  <v-card
                    elevation="0"
                    class="expand"
                    color="transparent"
                    style="overflow-x: hidden"
                  >
                    <v-row class="mt-n3 mb-6">
                      <v-col cols="3"> </v-col>
                      <v-col cols="2">
                        <h4 class="d-flex justify-center">Versions</h4>
                      </v-col>
                      <v-col cols="3">
                        <h4 class="d-flex justify-center">Date</h4>
                      </v-col>
                      <v-col cols="3">
                        <h4 class="d-flex justify-center">EditedBy</h4>
                      </v-col>
                      <v-col cols="1"> </v-col>
                    </v-row>
                    <v-row
                      class="mt-n10"
                      v-for="(item1, index1) in itemsVersions"
                      :key="index1"
                      @click="fileViewSend(item1)"
                      style="cursor: pointer"
                    >
                      <v-col cols="2"> </v-col>
                      <v-col cols="1">
                        <v-img
                          class="mt-n2"
                          contain
                          aspect-ratio="1"
                          width="37"
                          height="37"
                          :src="item1.filepng"
                          style="filter: drop-shadow(0 0 0.5rem #808080)"
                        >
                        </v-img>
                      </v-col>
                      <v-col cols="2">
                        <p class="d-flex justify-center">{{ item1.version }}</p>
                      </v-col>
                      <v-col cols="3">
                        <p class="d-flex justify-center">
                          {{ item1.created_at }}
                        </p>
                      </v-col>
                      <v-col cols="3">
                        <p class="d-flex justify-center">{{ item1.owner }}</p>
                      </v-col>
                      <v-col cols="1"> </v-col>
                    </v-row>
                    <!-- <v-row
                      class="mt-n6"
                      v-for="(item1, index1) in itemsVersions"
                      :key="index1"
                      @click="fileViewSend(item1)"
                      style="cursor: pointer"
                    >
                      <v-col cols="1"> </v-col>
                      <v-col cols="2">
                        <v-img
                          contain
                          aspect-ratio="1"
                          width="75"
                          height="75"
                          :src="item1.filepng"
                        >
                        </v-img>
                      </v-col>
                      <v-col cols="1" class="d-flex justify-center">
                        <h4 class="mt-9">{{ item1.version }}</h4>
                      </v-col>
                      <v-col cols="3" class="d-flex justify-center">
                        <p class="mt-9">{{ item1.created_at }}</p>
                      </v-col>
                      <v-col cols="4" class="d-flex justify-center">
                        <p class="mt-9">{{ item1.owner }}</p>
                      </v-col>
                    </v-row> -->
                    <v-divider class="mx-16 ml-15"></v-divider>
                  </v-card>
                </div>
              </div>
            </v-card>
          </ul>
          <ul
            v-if="layout === 'list'"
            class="list"
            style="font-family: Nunito Sans"
          >
            <v-expansion-panels
              :style="{ background: $vuetify.theme.themes[theme].background }"
            >
              <v-expansion-panel
                :style="{
                  background: $vuetify.theme.themes[theme].background,
                }"
                v-model="valueE"
                v-for="(item, index) in serverItems"
                :key="index"
              >
                <v-expansion-panel-header
                  style="height: 14vh"
                  @click.native="list(item)"
                >
                  <template v-slot:actions>
                    <v-icon class=""></v-icon>
                  </template>
                  <v-row>
                    <v-col cols="2" class="pa-0 ma-0">
                      <v-img
                        class="mr-n2"
                        contain
                        aspect-ratio="1"
                        width="119"
                        height="119"
                        :src="item.filepng"
                        style="filter: drop-shadow(0 0 0.5rem #808080)"
                      ></v-img>
                    </v-col>
                    <v-col cols="3" class="ma-0 pa-0 mt-14 pl-3">
                      <p
                        style="font-size: 16px; font-weight: 600; opacity: 0.8"
                      >
                        {{ item.filename }}
                      </p>
                    </v-col>
                    <v-col cols="3" class="ma-0 pa-0 mt-1">
                      <!-- <v-avatar
                        class="mr-2 mt-14"
                        v-for="(item, index) in itemscolor"
                        :key="index"
                        :color="item.color"
                        @click="colorf(item)"
                        size="13"
                      ></v-avatar> -->
                      <!-- this will be added when we will work on assets -->
                    </v-col>
                    <v-col
                      cols="3"
                      class="mt-15 ma-0 pa-0 d-flex justify-center"
                    >
                      <p
                        style="
                          font-size: 11px;
                          font-weight: 900 !important;
                          letter-spacing: 2px;
                        "
                      >
                        {{ item.versions }}
                        VERSIONS
                      </p>
                      <!-- <v-avatar
                        class="ml-2 mt-13"
                        v-for="(item, index) in itemscolor"
                        :key="index"
                        :color="item.color"
                        @click="colorf(item)"
                        size="15"
                      ></v-avatar> -->
                    </v-col>
                    <v-col cols="1" class="pa-0 ma-0 mt-1">
                      <v-btn icon class="mt-11" @click="deleteItem(item)">
                        <v-icon> mdi-delete-outline </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="ma-0 pa-0">
                    <v-col cols="1"></v-col>
                    <v-col cols="10">
                      <v-divider
                        class="mt-n4 mx-6"
                        style="border-color: rgba(211, 211, 211, 0.4)"
                      ></v-divider>
                    </v-col>
                    <v-col cols="1"></v-col>
                  </v-row>
                  <v-card
                    elevation="0"
                    class="mt-n2 mb-n8"
                    color="transparent"
                    style="overflow-x: hidden"
                  >
                    <v-row class="mt-3 mb-4">
                      <v-col cols="3"> </v-col>
                      <v-col cols="3">
                        <h4>Versions</h4>
                      </v-col>
                      <v-col cols="3">
                        <h4>Date</h4>
                      </v-col>
                      <v-col cols="3">
                        <h4>Edited By</h4>
                      </v-col>
                    </v-row>
                    <div class="ma-0 pa-0 mt-5">
                      <v-row
                        class="mt-n8"
                        v-for="(item1, index1) in itemsVersions"
                        :key="index1"
                        @click="fileViewSend(item1)"
                        style="cursor: pointer; font-size: 12px"
                      >
                        <v-col cols="3" class="mt-n1 d-flex justify-center">
                          <v-img
                            style="
                              margin-top: -0.6em;
                              filter: drop-shadow(0 0 0.5rem #808080);
                            "
                            contain
                            aspect-ratio="1"
                            width="37"
                            height="37"
                            :src="item1.filepng"
                          >
                          </v-img>
                        </v-col>
                        <v-col cols="3">
                          <p>Version {{ item1.version }}</p>
                        </v-col>
                        <v-col cols="3">
                          <p>
                            {{ item1.created_at }}
                          </p>
                        </v-col>
                        <v-col cols="3">
                          <!-- class="d-flex justify-center" -->
                          <p>{{ item1.owner }}</p>
                        </v-col>
                      </v-row>
                    </div>
                    <v-row class="ma-0 pa-0">
                      <v-col cols="1"></v-col>
                      <v-col cols="10">
                        <v-divider
                          class="mx-6"
                          style="border-color: rgba(211, 211, 211, 0.4)"
                        ></v-divider>
                      </v-col>
                      <v-col cols="1"></v-col>
                    </v-row>
                  </v-card>
                  <!-- <v-card
                    elevation="0"
                    class="expand"
                    color="transparent"
                    style="overflow-x: hidden"
                  >
                    <v-row
                      class="mt-n4 ml-3"
                      v-for="(item1, index1) in itemsVersions"
                      :key="index1"
                      @click="fileViewSend(item1)"
                      style="cursor: pointer"
                    >
                      <v-col cols="3">
                        <v-img
                          contain
                          aspect-ratio="1"
                          width="70"
                          height="70"
                          :src="item1.filepng"
                        >
                        </v-img>
                      </v-col>
                      <v-col cols="3">
                        <h4 class="mt-6">{{ item1.version }}</h4>
                      </v-col>
                      <v-col cols="3">
                        <p class="mt-6">{{ item1.created_at }}</p>
                      </v-col>
                      <v-col cols="3">
                        <p class="mt-6">{{ item1.owner }}</p>
                      </v-col>
                    </v-row>
                  </v-card> -->
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </ul>
        </v-content>
      </v-card>
    </v-card>

    <v-btn
      v-if="augmentableTheme"
      @click="openCMSBig()"
      icon
      style="
        position: absolute !important;
        z-index: 10000000;
        right: 1em;
        bottom: 1em;
      "
    >
      <md-icon
        class="md-size-2x"
        md-src="/static/assets/svg/white/Fullscreen.svg"
      ></md-icon>
    </v-btn>
    <v-btn
      v-if="!augmentableTheme"
      @click="openCMSBig()"
      icon
      style="
        position: absolute !important;
        z-index: 10000000;
        right: 1em;
        bottom: 1em;
      "
    >
      <md-icon
        class="md-size-2x"
        md-src="/static/assets/svg/black/Fullscreen.svg"
      ></md-icon>
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

import { mapState } from "vuex";

export default {
  name: "cmsismaillarge",
  data: function () {
    return {
      //itemsversions1check:true,
      search: "",
      gridTick: 0,
      listTick: 1,
      itemsVersions1: [
        {
          version: "version 01",
          created_at: "12.20.2021",
          owner: "kajal",
          filepng: "/static/assets/images/screenshot.png",
        },
        {
          version: "version 01",
          created_at: "12.20.2021",
          owner: "kajal",
          filepng: "/static/assets/images/screenshot.png",
        },
        {
          version: "version 03",
          created_at: "05.24.2021",
          owner: "king1",
          filepng: "/static/assets/images/screenshot(1).png",
        },
        {
          version: "version 04",
          created_at: "03.23.2021",
          owner: "minhaj",
          filepng: "/static/assets/images/screenshot(2).png",
        },
        {
          version: "version 05",
          created_at: "04.20.2021",
          owner: "raju4",
          filepng: "/static/assets/images/screenshot(3).png",
        },
        {
          version: "version 06",
          created_at: "09.20.2021",
          owner: "raju5454",
          filepng: "/static/assets/images/screenshot(1).png",
        },
        {
          version: "version 07",
          created_at: "10.12.2021",
          owner: "raju66",
          filepng: "/static/assets/images/screenshot(2).png",
        },
      ],
      select: "",
      carouselItems: [],
      valueE: "",
      darkTheme: false,
      lightTheme: false,
      colorTheme: "",
      dataitem: [],
      griddata: true,
      gridItemView: false,
      layout: "list",
      colors: [
        "green",
        "secondary",
        "yellow darken-4",
        "red lighten-2",
        "orange darken-1",
      ],
      cycle: false,
      arrow: false,

      itemscolor: [
        { color: "yellow" },
        { color: "blue" },
        { color: "red" },
        { color: "pink" },
        { color: "orange" },
      ],

      slides: ["First", "Second", "Third", "Fourth", "Fifth"],
      items: [
        /*
        "static/assets/images/screenshot.png",
        "static/assets/images/screenshot(1).png",
        "static/assets/images/screenshot(2).png",
        "static/assets/images/screenshot(3).png",
        "static/assets/images/screenshot.png",
        "static/assets/images/screenshot(1).png",
        "static/assets/images/screenshot(2).png",
        "static/assets/images/screenshot(3).png",
        */
      ],

      loading: false,

      serverItems: [],
      fileNamesofServer: [],
      itemsVersions: [],

      headers: [
        {
          text: "Dessert (100g serving)",
          align: "start",
          value: "name",
        },
        { text: "Calories", value: "calories" },
        { text: "Fat (g)", value: "fat" },
        { text: "Carbs (g)", value: "carbs" },
        { text: "Protein (g)", value: "protein" },
        { text: "Iron (%)", value: "iron" },
      ],
      itemsgrid: [
        // grid  data 1
        {
          filepng: "/static/assets/images/screenshot.png",
          filepng1: "",
          filename: "Rivalry H68568 R",
          version: "Version ",
          date: "Date",
          Editedby: "Editedby",
        },

        // grid  data 2
        {
          filepng: "/static/assets/images/screenshot(1).png",
          filepng1: "static/assets/images/screenshot(1).png",
          filename: "Rivalry H68568 R",
          version: "version 05",
          date: "22.43.1223",
          Editedby: "sidrss",
        },

        // grid  data 3
        {
          filepng: "/static/assets/images/screenshot(2).png",
          filepng1: "static/assets/images/screenshot(2).png",
          filename: "Rivalry H68568 R",
          version: "version 06",
          date: "32.44.33",
          Editedby: "ssff",
        },

        // grid  data 4
        {
          filepng: "/static/assets/images/screenshot(3).png",
          filepng1: "static/assets/images/screenshot(3).png",
          filename: "Rivalry H68568 Rg4",
          version: "version 07",
          date: "43.88.89",
          Editedby: "dgfgj",
        },

        // grid  data 5
        {
          filepng: "/static/assets/images/screenshot(1).png",
          filepng1: "static/assets/images/screenshot(1).png",
          filename: "Rivalry H68568 R",
          version: "version 08",
          date: "44.63.41",
          Editedby: "ttyh",
        },

        // grid  data 6
        {
          filepng: "/static/assets/images/screenshot.png",
          filepng1: "static/assets/images/screenshot.png",
          filename: "Rivalry H68568 R",
          version: "version 09",
          date: "11.23.33",
          Editedby: "erewr",
        },
      ],
      items1: [
        {
          filepng: "folder",
          iconClass: "grey lighten-1 white--text",
          filename: "Photos",
          subtitle: "Jan 9, 2014",
        },
        {
          icon: "folder",
          iconClass: "grey lighten-1 white--text",
          title: "Recipes",
          subtitle: "Jan 17, 2014",
        },
        {
          icon: "folder",
          iconClass: "grey lighten-1 white--text",
          title: "Work",
          subtitle: "Jan 28, 2014",
        },
      ],
      items2: [
        {
          icon: "mdi-file",
          title: "Vacation itinerary",
          subtitle: "Jan 20, 2014",
        },
        {
          icon: "mdi-file",
          title: "Kitchen remodel",
          subtitle: "Jan 10, 2014",
        },
      ],
      fullCMS: false,
    };
  },
  computed: {
    ...mapState(["augmentableTheme"]),

    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
  watch: {
    augmentableTheme: function (val) {
      if (val === true) {
        this.lightTheme = false;
        this.darkTheme = true;
        this.colorTheme = "#d3d3d3";
      } else {
        this.lightTheme = true;
        this.darkTheme = false;
        this.colorTheme = "black";
      }
    },
    select: function (val) {
      // var st;
      //define split as defined above in v-autocomplete item-value
      // st = val.split(" - ");
      // this.fileViewSend(st[1], st[0]);
      this.fileViewSend(val);
    },
  },
  mounted() {
    this.getAllFiles();

    if (this.augmentableTheme === true) {
      this.darkTheme = true;
      this.colorTheme = "#d3d3d3";
    } else {
      this.lightTheme = true;
      this.colorTheme = "black";
    }
  },
  methods: {
    changeLayout(x) {
      this.layout = x;
      if (x === "list") {
        this.gridTick = 0;
        this.listTick = 1;
      } else if (x === "grid") {
        this.gridTick = 1;
        this.listTick = 0;
      }
    },

    colorf(x) {
      alert(x.color);
    },

    funcc(glb, id) {
      this.$emit("location", glb, id);
      //console.log("hi image click");
    },
    printEd(x) {
      console.log(x);
      console.log("Edit");
    },
    getAllFiles() {
      axios
        .get(this.$abServerPath + "/api/glbfiles/glbgetallfile/", {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Token " + this.getAuthCookie("augmentableUserToken") + "",
          },
        }) //for local "/api/glb/glbgetallfile/"
        .then((response) => {
          var i;
          var len;

          var item = {
            id: "",
            slug: "",
            filename: "",
            filetype: "",
            fileglb: "",
            filepng: "",
            filesize: "",
            created_at: "",
            updated_at: "",
            tags: "",
            state: "",
            description: "",
            version: "",
            //added to check the total versions of specific file
            versions: 1,
          };

          for (i = 0, len = response.data.length; i < len; i++) {
            item = response.data[i];
            item.id = response.data[i].id;
            item.slug = response.data[i].slug;
            item.filename = response.data[i].filename;
            item.filetype = response.data[i].filetype.toUpperCase();
            item.fileglb = this.$abServerPath + "" + response.data[i].fileglb;
            item.filepng = this.$abServerPath + "" + response.data[i].filepng;
            item.fileusdz = this.$abServerPath + "" + response.data[i].fileusdz;
            item.filesize = response.data[i].filesize;
            item.created_at = this.dateFormat(response.data[i].created_at);
            item.updated_at = response.data[i].updated_at;
            item.tags = response.data[i].tags;
            item.state = response.data[i].state;
            item.description = response.data[i].description;
            item.version = response.data[i].version;

            if (this.fileNamesofServer.includes(response.data[i].filename)) {
              var index = this.serverItems.findIndex(
                (x) => x.filename === response.data[i].filename
              );
              this.serverItems[index].versions =
                this.serverItems[index].versions + 1;
              continue;
            }
            item.versions = 1;
            // this.fileNamesofServer.push(response.data[i].filename);
            // this.serverItems.push(item);
            this.fileNamesofServer.unshift(response.data[i].filename);
            this.serverItems.unshift(item);
          }
        })
        .catch((error) => {
          console.log(error);
          //this.errored = true;
        });
    },
    deleteItem(item) {
      this.actionClick = true;
      console.log(item.id);

      confirm("Are you sure you want to delete this item?") &&
        this.deleteServerItem(item.id);
    },

    deleteServerItem(y) {
      console.log(y);
      console.log("Delete");

      axios
        .delete(this.$abServerPath + "/api/glbfiles/glbdeletefile/" + y + "/", {
          headers: {
            Authorization:
              "Token " + this.getAuthCookie("augmentableUserToken") + "",
          },
        }) //for local "/api/glb/glbgetallfile/"
        .then((response) => {
          console.log(response);

          axios
            .get(this.$abServerPath + "/api/glbfiles/glbgetallfile/", {
              headers: {
                "Content-Type": "application/json",
                Authorization:
                  "Token " + this.getAuthCookie("augmentableUserToken") + "",
              },
            }) //for local "/api/glb/glbgetallfile/"
            .then((response) => {
              this.serverItems = [];
              var i;
              var len;

              var item = {
                id: "",
                slug: "",
                filename: "",
                filetype: "",
                fileglb: "",
                filepng: "",
                filesize: "",
                created_at: "",
                updated_at: "",
                tags: "",
                state: "",
                description: "",
                version: "",
              };

              for (i = 0, len = response.data.length; i < len; i++) {
                item = response.data[i];
                item.id = response.data[i].id;
                item.slug = response.data[i].slug;
                item.filename = response.data[i].filename;
                item.filetype = response.data[i].filetype.toUpperCase();
                item.fileglb =
                  this.$abServerPath + "" + response.data[i].fileglb;
                item.filepng =
                  this.$abServerPath + "" + response.data[i].filepng;
                item.fileusdz =
                  this.$abServerPath + "" + response.data[i].fileusdz;
                item.filesize = response.data[i].filesize;
                item.created_at = this.dateFormat(response.data[i].created_at);
                item.updated_at = response.data[i].updated_at;
                item.tags = response.data[i].tags;
                item.state = response.data[i].state;
                item.description = response.data[i].description;
                item.version = response.data[i].version;

                if (
                  this.fileNamesofServer.includes(response.data[i].filename)
                ) {
                  continue;
                }
                // this.fileNamesofServer.push(response.data[i].filename);
                // this.serverItems.push(item);
                this.fileNamesofServer.unshift(response.data[i].filename);
                this.serverItems.unshift(item);
              }
            })
            .catch((error) => {
              console.log(error);
              //this.errored = true;
            });
        })
        .catch((error) => {
          console.log(error);
          //this.errored = true;
        });
    },
    openCMSBig() {
      this.$router.push({ path: "/assets" });
    },
    grid(x) {
      this.dataitem = x;
      this.griddata = false;
      this.fileViewSend(x);
      this.listFilesVersions(x);
    },
    list(x) {
      this.fileViewSend(x);
      this.listFilesVersions(x);
    },
    listFilesVersions(x) {
      //for versions show
      axios
        .get(
          this.$abServerPath +
            "/api/glbfiles/glbgetfileversions/" +
            x.filename +
            "/",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          }
        )
        .then((response) => {
          this.itemsVersions = [];
          var i;
          var len;

          var item = {
            id: "",
            slug: "",
            filename: "",
            filetype: "",
            fileglb: "",
            filepng: "",
            filesize: "",
            created_at: "",
            updated_at: "",
            tags: "",
            state: "",
            description: "",
            version: "",
            linkHDR: "",
          };

          for (i = 0, len = response.data.length; i < len; i++) {
            item = response.data[i];
            item.id = response.data[i].id;
            item.slug = response.data[i].slug;
            item.filename = response.data[i].filename;
            item.filetype = response.data[i].filetype;
            item.fileglb = this.$abServerPath + "" + response.data[i].fileglb;
            item.filepng = this.$abServerPath + "" + response.data[i].filepng;
            item.fileusdz = this.$abServerPath + "" + response.data[i].fileusdz;
            item.filesize = response.data[i].filesize;
            item.created_at = this.dateFormat(response.data[i].created_at);
            item.updated_at = response.data[i].updated_at;
            item.tags = response.data[i].tags;
            item.state = response.data[i].state;
            item.description = response.data[i].description;
            item.version = response.data[i].version;
            item.linkHDR = "" + response.data[i].linkHDR;
            this.itemsVersions.push(item);
          }
        })
        .catch((error) => {
          console.log(error);
          //this.errored = true;
        });
      //for versions show
    },
    fileViewSend(x) {
      //added for file to showup again in the viewer
      this.$store.commit("setFileDetail", x);
      //added
      this.carouselItems = [];
      this.carouselItems.push(x);
      this.funcc(x.fileglb, x.id);
    },
    dateFormat(x) {
      return (
        "" + x.slice(8, 10) + "." + x.slice(5, 7) + "." + x.slice(0, 4) + ""
      );
    },
    getAuthCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    toggleView() {
      var view = document.getElementById("picsView");
      var cms = document.getElementById("cmsView");
      var mid1 = document.getElementById("midB1");
      var mid2 = document.getElementById("midB2");
      //view.setAttribute("style", "");
      //cms.setAttribute("style", "");
      if (this.fullCMS === false) {
        this.fullCMS = true;
        view.style.height = "0%";
        view.style.top = "0";
        cms.style.height = "100%";
        cms.style.top = "0";
        mid1.style.top = "1%";
        mid2.style.top = "1%";
      } else {
        this.fullCMS = false;
        view.style.height = "55%";
        view.style.top = "0";
        cms.style.height = "55%";
        cms.style.top = "55%";
        mid1.style.top = "56%";
        mid2.style.top = "56%";
      }
    },
  },
};
</script>


<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Raleway:200,300,400,600,700,800,900");
@import url("https://fonts.googleapis.com/css?family=Nunito Sans:200,300,400,600,700,800,900");

.picsArea {
  width: 100%;
  height: 55%;
  //background-color: transparent;

  // -webkit-box-shadow: 10px 10px 10px #000;
  // -moz-box-shadow: 10px 10px 10px #000;
  //  -o-box-shadow:10px 10px 10px #000;
  //   box-shadow: 10px 10px 10px #000;

  // -moz-box-shadow: 0 0 15px 0 #ebebeb;
  // -webkit-box-shadow: 0 0 15px 0 #ebebeb;
  // box-shadow: 0 0 15px 0 #ebebeb;

  // -webkit-box-shadow: 0 10px 5px blue;
  //   -moz-box-shadow: 0 10px 5px blue;
  //border-bottom: 2px solid red ;
  //box-shadow: inset 0 0 5px 0 red ;
  // box-shadow: 0 0 10px 5px red;
  //  box-shadow:  0 0  9px 0 red;
  // border-bottom: 2px solid blue;
  position: absolute;
  // z-index: 1;
}
// .foldersArea1 {
//   top: 51%;
//   width: 100%;
//   height: 7%;
//    z-index: 2;
//   background-color:white;
//   position: absolute;
// }
.foldersArea2 {
  top: 55%;
  width: 100%;
  height: 45%;
  //background-color: white;
  position: absolute;
}
.innerFolderArea {
  top: 20%;
  left: 20%;
  width: 60%;
  height: 60%;
  //background-color: white;
  position: absolute;
}

.tool-bar {
  //background-color: white;
  position: relative;
  width: 100%;
}

.tool-bar a {
  background: rgba(255, 255, 255, 0.5) center center no-repeat;
  border: 1px solid #e4e4e4;
  border-right: 1px solid #908f8f;
  border-bottom: 1px solid #908f8f;
  cursor: pointer;
  text-align: right;
  display: inline-block;
  height: 32px;
  margin-left: 86%;
  margin-right: -84%;
  text-decoration: none;
  width: 32px;
}

.tool-bar a:hover {
  border: 1px solid #e4e4e4;
}

.tool-bar a.active {
  background-color: rgba(0, 0, 0, 0.5);
  border: 1px solid #908d8d;
  border-right: 1px solid #e2e2e2;
  border-bottom: 1px solid #e2e2e2;
}

.tool-bar a.active:hover {
  cursor: default;
}

.tool-bar a.list-icon {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkYzNkFCQ0ZBMTBCRTExRTM5NDk4RDFEM0E5RkQ1NEZCIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkYzNkFCQ0ZCMTBCRTExRTM5NDk4RDFEM0E5RkQ1NEZCIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RjM2QUJDRjgxMEJFMTFFMzk0OThEMUQzQTlGRDU0RkIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RjM2QUJDRjkxMEJFMTFFMzk0OThEMUQzQTlGRDU0RkIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7h1bLqAAAAWUlEQVR42mL8////BwYGBn4GCACxBRlIAIxAA/4jaXoPEkMyjJ+A/g9MDJQBRhYg8RFqMwg8RJIUINYLFDmBUi+ADQAF1n8ofk9yIAy6WPg4GgtDMRYAAgwAdLYwLAoIwPgAAAAASUVORK5CYII=");
}

.tool-bar a.grid-icon {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjBEQkMyQzE0MTBCRjExRTNBMDlGRTYyOTlBNDdCN0I4IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjBEQkMyQzE1MTBCRjExRTNBMDlGRTYyOTlBNDdCN0I4Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MERCQzJDMTIxMEJGMTFFM0EwOUZFNjI5OUE0N0I3QjgiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MERCQzJDMTMxMEJGMTFFM0EwOUZFNjI5OUE0N0I3QjgiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4MjPshAAAAXklEQVR42mL4////h/8I8B6IGaCYKHFGEMnAwCDIAAHvgZgRyiZKnImBQsACxB+hNoDAQyQ5osQZIT4gH1DsBZABH6AB8x/JaQzEig++WPiII7Rxio/GwmCIBYAAAwAwVIzMp1R0aQAAAABJRU5ErkJggg==");
}

/* Grid layout */
.grid {
  background-color: transparent;
  list-style: none;
  margin: 0 auto;
  padding: 0;
  width: 100%;
}

.grid li {
  display: inline-block;
  position: relative;

  width: 23%;
}
/* List layout */
.list {
  background-color: transparent;
  list-style: none;
  margin: 0 auto;
  padding: 0;
  width: 100%;
}

.expand {
  overflow-y: auto !important;
  scrollbar-color: #a0a0a0 transparent;
  scrollbar-width: thin;
}

.expand::-webkit-scrollbar {
  width: 5px;
}

.expand::-webkit-scrollbar-track {
  background: transparent;
}
.expand::-webkit-scrollbar-thumb {
  background: #a0a0a0;
  border-radius: 10px;
}

.v-expansion-panel::before {
  box-shadow: none;
}
</style>